module.exports = __webpack_public_path__ + "img/136.ff79a66d.jpg";